import { render, staticRenderFns } from "./CommonGoToTop.vue?vue&type=template&id=5c8c515e&scoped=true&"
import script from "./CommonGoToTop.vue?vue&type=script&lang=js&"
export * from "./CommonGoToTop.vue?vue&type=script&lang=js&"
import style0 from "./CommonGoToTop.vue?vue&type=style&index=0&id=5c8c515e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8c515e",
  null
  
)

export default component.exports